if (!customElements.get('custom-modal')) {
  class Modal extends HTMLElement {
    constructor() {
      super();
      this.activeId = null;
    }
    
    close() {
      document.querySelector(`[data-drawer-action="open"][data-drawer-id="${this.activeId}"]`)?.focus();
      switch(this.direction) {
        case 'left':
          this.classList.add('opacity-0', '-translate-x-full')
          setTimeout(() => {
            this.classList.remove('opacity-0', '-translate-x-full')
          }, 500);
        break;
        case 'center':
          this.classList.add('opacity-0');
          setTimeout(() => {
            this.classList.remove('opacity-0');
          }, 500);
        break;
        case 'right': 
          this.classList.add('opacity-0', 'translate-x-full')
          setTimeout(() => {
            this.classList.remove('opacity-0', 'translate-x-full')
          }, 500);
        break;
      }
        
      this.template.innerHTML = this.innerHTML;
      
      setTimeout(() => {
        this.classList.add('hidden');
        document.body.classList.remove('overlay');
        this.classList.remove('top-0', 'bottom-0', 'left-0', 'w-full', 'h-full', 'z-20', 'opacity-0', 'transition-all', 'duration-500');
        this.innerHTML = '';
        this.activeId = null;
      }, 500);
      
    }
    
    open(drawerId) {
      this.template = document.querySelector(`[data-drawer-content="${drawerId}"]`); 
      if (!this.template) return;       
      
      const predictive_search = document.querySelector('predictive-search')
      if (predictive_search?.close) { predictive_search.close(); }
      this.direction = this.template.dataset?.direction ?? 'left';
      this.classList.add('opacity-0');
      
      if (this.activeId !== drawerId) {
        this.activeId = drawerId;
        const content = this.template.content?.cloneNode(true) || this.template.cloneNode(true);
        this.replaceChildren(content);
        this.classList.remove('hidden');
        this.classList.add(this.direction);
        setTimeout(() => {
          document.body.classList.add('overlay');
          this.querySelector('[data-drawer-action="close"]')?.focus();
          
          this.classList.add('top-0', 'bottom-0', 'left-0', 'w-full', 'h-full', 'z-20', 'opacity-0');
        }, 10);
      }
      switch(this.direction) {
        case 'left':
          this.classList.add('-translate-x-full', 'transition-all', 'duration-500');
        break;
        case 'center':
          this.classList.add('transition-all', 'duration-500');
        break;
        case 'right': 
          this.classList.add('translate-x-full', 'transition-all', 'duration-500');
        break;
      }
      
      setTimeout(() => {
        switch(this.direction) {
          case 'left':
            this.classList.remove('opacity-0', '-translate-x-full')
          break;
          case 'center':
            this.classList.remove('opacity-0')
          break;
          case 'right': 
            this.classList.remove('opacity-0', 'translate-x-full')
          break;
        }
      }, 10);
    }
    
    connectedCallback() {
      window.addEventListener('modal:openById', (e) => {
        this.open(e.detail);
      });
      
      window.addEventListener('click', (e) => {
        if (e.target.tagName.toLowerCase() === 'custom-modal') {
          this.close();
        }
        
        const clickedElement = e.target.closest('[data-drawer-action]');
        if (!clickedElement) return;
        
        const {
          drawerAction,
          drawerId
        } = clickedElement.dataset;
                      
        switch (drawerAction) {
          case 'open':    
            e.preventDefault();
            this.open(drawerId);
          break;
          case 'close':
            this.close();
          break;
          default: break;
        }
      });
    }
  }
  
  customElements.define('custom-modal', Modal);
}